import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../redux/actions";

import Modal from "../Modal";
import accessAPI from '../../../api/acesssAPI'

const AnotherSessionModal = ({ isOpen, onClose = () => {} }) => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.authReducer.user)

  const handleClose = async () => {
    onClose()
    if (user) {
      await accessAPI.logout()
      dispatch(authActions.logout())
    }
  }
  
  return (
    <Modal
      visible={isOpen}
      onClose={handleClose}
      title="Sesión duplicada"
      color="var(--ripley-salmon)"
      titleImage={require("../../../../assets/icons/ic_disconnected.svg")}
      btn1={{
        text: "Aceptar",
        onClick: handleClose,
      }}
    >
      <div className="modal-error">
        <p>
          Ya iniciaste sesión en otro dispositivo, vuelve a iniciar sesión para
          continuar.
        </p>
      </div>
    </Modal>
  );
};

export default AnotherSessionModal;
